module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"video_upload_error":{"default":"動画のアップロードに失敗しました。","too_large":"動画は最大500MBまでアップロード可能です。","invalid_type":"動画ファイルではありません。"},"video_create_error":{"default":"動画のアップロード中にエラーが発生しました。"}}}')
  delete Component.options._Ctor
}
